<!-- src/components/FeatureNotification/GlobalNewFeatureNotification.vue -->
<template>
  <NewFeatureNotification 
    v-model:visible="visible" 
    @handleOk="handleOk"
  />
</template>

<script lang="ts" setup>
import { useNewFeatureNotification } from '/@/hooks/web/useNewFeatureNotification';
import NewFeatureNotification from './NewFeatureNotification.vue';
import { useGo } from '/@/hooks/web/usePage';
const go = useGo()

const { visible, closeNewFeatureNotification } = useNewFeatureNotification();
const handleOk = () => {
  // 处理用户点击"我知道了"的事件
  closeNewFeatureNotification();
  go({
    path: `/project/list`,
  });
};
</script>